<template>
  <v-autocomplete
    v-model="selectedCountries"
    :items="countries"
    label="Countries"
    variant="underlined"
    menu-icon="mdi-chevron-down"
    :menu-props="{ scrollStrategy: 'none' }"
    multiple
    chips
    clearable
  >
  </v-autocomplete>
</template>

<script>
import countryList from "country-list"
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  computed: {
    countries() {
      return countryList.getNames()
    },
    selectedCountries: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit("update:modelValue", value || [])
      }
    }
  }
}
</script>
